import { Crop } from "react-image-crop";

export function getCanvas(crop: Crop, image?: HTMLImageElement) {
  if (!image) {
    return;
  }

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("No 2d context");
  }

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = Math.floor(crop.width);
  canvas.height = Math.floor(crop.height);

  ctx?.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return canvas;
}

export const uploadPictureInitialState = {
  imageSrc: "",
  cropImage: false,
  cropImageRef: undefined,
  croppedImageUrl: "",
  captureImage: false,
  error: "",
  openCamera: false,
  browserSupportError: false,
  cameraError: false
};

export const webCamInitialState = {
  loading: true,
  selectedDevice: undefined,
  devices: undefined,
  image: undefined,
  browserSupportError: false
};
